import { getConfig } from "../apiLoader/config";
import { updateSettings } from "../stores/settings";
import { isDemoMode, isEditorMode } from "../stores/mode";
import copyDefault from "../constants/copyDefault";
import get from "lodash/get";
import { getDomain } from "./domain";

export const loadMicrositeSettings = async () => {
  const domain = getDomain();
  let config = {};

  try {
    const response = await getConfig(domain);
    config = isEditorMode()
      ? {
          ...response.config,
          v2: {
            ...get(response.config, "v2", {}),
            flow: copyDefault.v2.flow // Assuming this will retain all available flow pages
          }
        }
      : response.config;
  } catch (error) {
    // FIXME: this should work of the editor with an unpublished campaign or when testing locally only
    // but I think we only know if it's an editor for an unpublished campaign too late in the game
    if (!isDemoMode()) {
      throw error;
    }
  }

  updateSettings(config);
};
